// fork overlay: fork-owned extension of OSS v4.14.2 (blob:ca2c6ddc7b7dc4d2)
// EVA-M6 (D19): wholesale replacement registering the /settings/eva route into the
// settings aggregator. Alias-form imports (D-07) so the overlay plugin resolves the
// fork eva.routes module; every other import is the OSS module, unchanged.
import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from 'dashboard/routes/dashboard/settings/account/account.routes';
import agent from 'dashboard/routes/dashboard/settings/agents/agent.routes';
import assignmentPolicy from 'dashboard/routes/dashboard/settings/assignmentPolicy/assignmentPolicy.routes';
import agentBot from 'dashboard/routes/dashboard/settings/agentBots/agentBot.routes';
import attributes from 'dashboard/routes/dashboard/settings/attributes/attributes.routes';
import automation from 'dashboard/routes/dashboard/settings/automation/automation.routes';
import auditlogs from 'dashboard/routes/dashboard/settings/auditlogs/audit.routes';
import billing from 'dashboard/routes/dashboard/settings/billing/billing.routes';
import canned from 'dashboard/routes/dashboard/settings/canned/canned.routes';
import inbox from 'dashboard/routes/dashboard/settings/inbox/inbox.routes';
import integrations from 'dashboard/routes/dashboard/settings/integrations/integrations.routes';
import labels from 'dashboard/routes/dashboard/settings/labels/labels.routes';
import macros from 'dashboard/routes/dashboard/settings/macros/macros.routes';
import reports from 'dashboard/routes/dashboard/settings/reports/reports.routes';
import store from 'dashboard/store';
import sla from 'dashboard/routes/dashboard/settings/sla/sla.routes';
import teams from 'dashboard/routes/dashboard/settings/teams/teams.routes';
import customRoles from 'dashboard/routes/dashboard/settings/customRoles/customRole.routes';
import profile from 'dashboard/routes/dashboard/settings/profile/profile.routes';
import security from 'dashboard/routes/dashboard/settings/security/security.routes';
import conversationWorkflow from 'dashboard/routes/dashboard/settings/conversationWorkflow/conversationWorkflow.routes';
import captain from 'dashboard/routes/dashboard/settings/captain/captain.routes';
import eva from 'dashboard/routes/dashboard/settings/eva/eva.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...conversationWorkflow.routes,
    ...captain.routes,
    ...eva.routes,
  ],
};
